
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $1e15d82c7fe55789$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["13xUc","index.ed55799b.js","4DAoH","logo.6546dfe7.jpg","9bLtU","gym-icon.aa9e153b.png","89G56","dia-1.3ab99714.png","gu0Qd","dia-2.a948547d.png","fTBx5","dia-3.dbc35d68.png","120ms","dia-4.10c9e568.png","52gtG","dia-5.fb9f7a7e.png","8ftZp","dia-6.8a46c7e3.png","302C6","dia-7.75702b94.png","ajNAn","biceps-imagen.8ec904dd.png","7v48Q","hombro-imagen.59aaa168.png","gFM35","cuadriceps-imagen.c0efab93.png","6IJIQ","pecho-imagen.0031dc03.png","3oWBe","gluteos-imagen.307ae593.png","4siTH","Isquiotibiales-imagen.2e29d42d.png","2Q4Rx","espalda-imagen.ba08dcd7.png","7FArO","triceps-imagen.700af324.png","1R6WV","lumbar-imagen.9460d526.png","eTeHn","abdominales-imagen.7fde30b2.png","kaFzr","aductor-abductor.948c888c.png","edzRD","pantorrilla-imagen.d77372de.png","43b6M","gym-accessory.34790f9e.png","aAd4U","lista-alimentos-sustitutos.8a6385b4.png","7yeQP","sw.js","5h9CN","index.5c50fdf0.css"]'));


//# sourceMappingURL=index.runtime.c760f1ce.js.map
